import { Link } from '@reach/router';
import { navigate } from 'gatsby';
import React, { memo, useContext } from 'react';
import UserContext from '../../contexts/UserContext';
import Button from '../shared/Button';
import Logo from '../shared/Logo';

const Hero = ({ handleLogin }) => {
  const { user, loading } = useContext(UserContext);

  // const handleLogin = async () => {
  //   if (!user) {
  //     const token = await createCustomToken();
  //     signInWithCustomToken(token);
  //   }
  // };

  const handleGotoApp = () => navigate('/app/dashboard');

  return (
    <div className="flex flex-col justify-center items-center w-full h-full">
      <Link to="/">
        <span className="sr-only">YES Resume Builder</span>
        <Logo className="animate-pulse" size="256px" />
      </Link>

      <div className="mt-8">
        <div className="mt-12">
          {user ? (
            <Button
              onClick={handleGotoApp}
              isLoading={loading}
              className="mx-auto md:mx-0"
            >
              Get started
            </Button>
          ) : (
            <Button
              onClick={handleLogin}
              isLoading={loading}
              className="mx-auto md:mx-0"
            >
              Get started
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(Hero);
